import React, { FC } from 'react'
import { Table, TableProps } from 'antd'
import { HealthcareParty, TelecomType } from '@icure/cardinal-sdk'
import { CommonPlaceholder } from '../../../../common/CommonPlaceholder'
import { getTelecomBySystem } from '../../../../../helpers/patientDataManipulations'
import { useTranslation } from 'react-i18next'

interface DataType {
  key: string
  name: string
  phone: string
  email: string
}

interface PatientsTableProps {
  showSpinner: boolean
  doctorsList?: HealthcareParty[]
}

export const DoctorsTable: FC<PatientsTableProps> = ({ showSpinner, doctorsList }) => {
  const { t } = useTranslation()
  const columns: TableProps<DataType>['columns'] = [
    {
      title: t('doctors.column.name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('doctors.column.phone'),
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: t('doctors.column.email'),
      dataIndex: 'email',
      key: 'email',
    },
  ]

  const mappedDoctors = doctorsList?.map((doctor, index) => {
    return {
      key: doctor.id ?? index.toString(),
      name: doctor.name ?? '-',
      phone: getTelecomBySystem(doctor.addresses, TelecomType.Mobile) ?? '-',
      email: getTelecomBySystem(doctor.addresses, TelecomType.Email) ?? '-',
    }
  })
  const contactPerson = {
    email: 'contact@icure.com',
    phone: '+32 2 333 58 46',
  }

  return (
    <Table
      scroll={{ x: 'max-content' }}
      size="middle"
      bordered={true}
      columns={columns}
      dataSource={mappedDoctors}
      pagination={false}
      loading={showSpinner}
      locale={{
        emptyText: (
          <CommonPlaceholder
            borderless={true}
            title={t('doctors.empty.title')}
            content={
              <>
                <p>{t('doctors.empty.contactLine')}</p>
                <p>{t('doctors.empty.contactPrompt')}</p>
                <div>
                  <a href={`mailto:${contactPerson.email}`}>{contactPerson.email}</a> - <a href={`tel:${contactPerson.phone}`}>{contactPerson.phone}</a>
                </div>
              </>
            }
          />
        ),
      }}
    />
  )
}
